import { Component, Output, EventEmitter, SimpleChanges, OnInit, OnChanges, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { SlideInOutAnimation } from '../animations';
import { ViewEncapsulation, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { tap, map } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';

import * as tus from 'tus-js-client';

import { environment } from '../../environments/environment';
import { Logger } from '@core';

import { AuthQuery } from '@app/auth/auth.query';

import { JournalService, MailService, Mail } from '@core';
import { CookieService } from 'ngx-cookie-service';

import { AuthDataService } from '@app/auth/auth-data.service';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY } from '@angular/material/progress-spinner';

import { requireAtLeastOneCheckboxValidator } from '../@shared/validation/require-checkboxes-to-be-checked.validator';

import { ExhibitorService, Exhibitor, ExhibitorTable, ExhibitorSingle } from '../services/exhibitor.service';

const log = new Logger('Login');

enum myTabs {
  tabWwelcome = 0,
  tabLogin = 1,
  tabRegisterNew = 2,
  tabRegisterSuccess = 5,
  tabForgotPawd = 3,
  tabFirststart = 4,
}

@Component({
  selector: 'app-phuture-login',
  templateUrl: './phuture-login.component.html',
  styleUrls: ['./phuture-login.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          opacity: '1',
          'z-index': '100',
        })
      ),
      state(
        'out',
        style({
          opacity: '0',
          'z-index': '100',
        })
      ),
      transition('in => out', animate('800ms 200ms ease-out')),
      transition('out => in', animate('1000ms ease-in-out')),
    ]),
  ],
})
export class PhutureLoginComponent implements OnInit {
  _client = environment.client;
  _showTerms = environment.exhibitor_show_terms;
  _terms_check = environment.exhibitor_show_terms;
  _taxid_required = environment.taxid_required;

  // FORM config
  showDSGVO = environment.exhibitor_show_dsgvo;
  showStorno = environment.exhibitor_show_storno;
  showMedia = environment.exhibitor_show_media;
  linkTerms = environment.linkTerms;
  linkDSGVO = environment.linkDSGVO;
  linkStorno = environment.linkStorno;
  linkMedia = environment.linkMedia;

  /**
   * Superadmin-edited consent text for a Legal block (Event Config → Legal),
   * picked for the role's content language. Returns '' when nothing is saved so
   * the template falls back to its built-in inline wording.
   */
  legalHtml(role: 'visitor' | 'exhibitor', type: 'terms' | 'storno' | 'dsgvo' | 'media'): string {
    const env: any = environment;
    const lang = (env.legalLanguages && env.legalLanguages[role]) || (role === 'exhibitor' ? 'fr' : 'de');
    const v = env.legal && env.legal[role] && env.legal[role][type] && env.legal[role][type][lang];
    return typeof v === 'string' && v.trim() ? v : '';
  }

  showDays = false; // show the day selection info
  _day1 = environment.day_1;
  _day2 = environment.day_2;
  //_hotel_info = environment.hotel_info;

  // video
  video_source_dash = environment.video_source_dash;
  video_source_webm = environment.video_source_webm;
  video_source_mp4 = environment.video_source_mp4;

  // texting and content
  __txt_subline = environment.txt_Subline;
  __txt_eventDomain = environment.txt_Event_Domain;
  __txt_Welcome = environment.txt_Welcome;
  __txt_Welcome_Text = environment.txt_Welcome_Text;

  // environment
  _eventYear = environment.event_year;
  _hotel_info = environment.hotel_info;
  _event_space = environment.event_space;
  _event_date = environment.event_date;
  _book_night = environment.book_night;
  _cancel_date = environment.cancel_date;

  // internal-logistics config (dates/labels)
  _arrival_day_before_date = environment.arrival_day_before_date;
  _lunch_dates = environment.lunch_dates;
  _nimes_visit_label = environment.nimes_visit_label;

  // dynamic fields
  show_dyn_regions_ex = environment.show_dyn_regions_ex;
  caption_dyn_regions_ex = environment.caption_dyn_regions_ex;

  show_dyn_activities_ex = environment.show_dyn_activities_ex;
  caption_dyn_activities_ex = environment.caption_dyn_activities_ex;

  // ---
  myVideo: any = null;
  videoContainer: any = null;

  dialogIsShown: boolean = false;
  isToggle: boolean = false;
  imageName: string = '';
  videoTag: any = null;

  playing: boolean = false;
  playingIcon: string = 'pause';
  mute: boolean = true;
  muteIcon: string = 'volume_mute';
  eye: boolean = false;
  eyeIcon: string = 'visibility_off';

  activeTab: number = myTabs.tabWwelcome;

  version: string | null = environment.version;
  error: string | undefined;
  loginForm!: FormGroup;
  registerForm!: FormGroup;
  forgotForm!: FormGroup;
  isLoading = false;

  // firststart
  colLarge = 5;
  colXLarge = 5;
  showWelcome: boolean = true;
  myGroup: string = '';

  firstExhibitorForm: FormGroup;
  submitted = false;

  // exhibitor firststart data
  imageStorage = environment.eplusSystem + '/_fileDB/images/exhibitor/';
  _profile_image = '';
  _logo = '';
  _bild1 = '';
  _bild2 = '';
  _bild3 = '';
  _imagevideo = '';
  _presentationvideo = '';

  isLoginClicked = false;
  isRegisterNewClicked = false;
  isForgetClicked = false;

  @ViewChild('myPond') myPond: any;

  feedback: any;

  pondOptions = {
    class: 'my-filepond',
    credits: false,
    multiple: false,
    allowFileTypeValidation: true,
    acceptedFileTypes: ['image/png', 'image/jpeg'],
    labelFileTypeNotAllowed: 'File of invalid type: only JPG, PNG',
    fileValidateTypeLabelExpectedTypesMap: { 'image/jpeg': '.jpg', 'image/png': '.png' },
    allowImageValidateSize: true,
    imageValidateSizeMinWidth: 150,
    imageValidateSizeMinHeight: 150,
    allowImageResize: true,
    imageResizeTargetWidth: 2400,
    imageResizeTargetHeight: 1600,
    imageResizeMode: 'contain',
    imageResizeUpscale: true,
    imageCropAspectRatio: 1,
    labelIdle: 'déposer le fichier ici ou <a style="text-decoration:underline;">parcourir</a> ...',
    // acceptedFileTypes: ['image/jpeg, image/png'],
    server: {
      process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
        // fieldName is the name of the input field
        // file is the actual file object to send
        //debugger;
        //console.table(fieldName);
        const formData = new FormData();
        formData.append(fieldName, file, file.name);
        formData.append('filepond', file.name);

        formData.append('uid', '' + this.authQuery.userid);
        formData.append('fid', '' + this.authQuery.fid);
        formData.append('role', '' + this.authQuery.role);
        formData.append('imgtype', '' + fieldName);

        const request = new XMLHttpRequest();
        request.open('POST', environment.serverUrl + '/filepond/process');

        // set `Content-Type` header
        //request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        //xhr.setRequestHeader('Accept', "application/json");
        request.setRequestHeader('Access-Control-Allow-Headers', '*');

        // token
        request.setRequestHeader('Authorization', `Bearer ${this.authQuery.access_token}`);

        // Should call the progress method to update the progress to 100% before calling load
        // Setting computable to false switches the loading indicator to infinite mode
        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
        };

        // Should call the load method when done and pass the returned server file id
        // this server file id is then used later on when reverting or restoring a file
        // so your server knows which file to return without exposing that info to the client
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            // the load method accepts either a string (id) or an object
            load(request.responseText);
          } else {
            // Can call the error method if something is wrong, should exit after
            error('oh no');
          }
        };

        request.send(formData);

        // Should expose an abort method so the request can be cancelled
        return {
          abort: () => {
            // This function is entered if the user has tapped the cancel button
            request.abort();

            // Let FilePond know the request has been cancelled
            abort();
          },
        };
      },
      revert: 'filepond/revert',
      restore: 'filepond/restore?id=',
      fetch: 'filepond/fetch?data=',
      load: 'filepond/load',
    },
  };

  pondFiles = [
    // 'index.html'
  ];

  pondOptionsVideo = {
    ...this.pondOptions, // reuse all base options
    acceptedFileTypes: ['video/mp4', 'video/webm'], // allow web-safe video
    labelFileTypeNotAllowed: 'File of invalid type: only MP4 or WebM',
    fileValidateTypeLabelExpectedTypesMap: {
      'video/mp4': '.mp4',
      'video/webm': '.webm',
    },
    imageValidateSizeMinWidth: undefined, // not needed for video
    imageValidateSizeMinHeight: undefined,
    allowImageValidateSize: false,
    allowImageResize: false,
    imageResizeTargetWidth: undefined,
    imageResizeTargetHeight: undefined,
    imageCropAspectRatio: undefined,
  };

  /*
      process: (fieldName, file, metadata, load, error, progress, abort) => {
        let that = this;

        that.feedback = 'Processing..';

        console.log(file);

        var upload = new tus.Upload(file, {
          endpoint: environment.serverUrl + '/filepond/process',
          retryDelays: [0, 1000, 3000, 5000],
          metadata: {
            ...metadata,
            filename: file.name,
            filetype: file.type,
            freddy: 'mercury',
            file: file,
          },

          async onBeforeRequest(req) {
            const token = await that.authQuery.access_token;
            req.setHeader('Authorization', `Bearer ${token}`);
          },

          onError: function (err) {
            that.feedback = 'Failed because: ' + err;
            console.log('Failed because: ' + err);
            error(err);
          },
          onProgress: function (bytesUploaded, bytesTotal) {
            that.feedback = 'Upload progress';
            progress(true, bytesUploaded, bytesTotal);

            const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
            console.log(bytesUploaded, bytesTotal, percentage + '%');
          },
          onChunkComplete: (chunkSize: number, bytesAccepted: number) => {},
          onSuccess: function () {
            console.log('Download from %s complete', upload.url);
            (that.feedback = 'Download from %s complete'), upload.url;
            // blob is now outside of zone
            that.feedback = upload.url;
            console.log(that.feedback);
            //this.cdr.detectChanges();
            //load(upload.url.split('/').pop());
          },
        });
        // Start the upload
        //upload.options.onSuccess = () => this.pondHandleSuccess(this);
        upload.start();

        return {
          abort: () => {
            upload.abort();
            abort();
          },
        };
      },
      */

  // acitivities --> exhibitor
  activities_en: any = [];
  activities_fr: any = [];

  EVENT_CATEGORIES: string[] = environment.EVENT_CATEGORIES;

  // firststart DATA
  fsData: any;
  fsShowFiles = false;

  isMobile = false;
  isTablet = false;
  isDesktop = false;

  constructor(
    private element: ElementRef,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private authService: AuthDataService,
    private authQuery: AuthQuery,
    private router: Router,
    private route: ActivatedRoute,
    private journalService: JournalService,
    private cookieService: CookieService,
    private deviceService: DeviceDetectorService,
    private exhibitorService: ExhibitorService,
    private cdr: ChangeDetectorRef
  ) {
    // GET THE DEVICE INFO
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktop = this.deviceService.isDesktop();

    // INIT THE FORMS
    // create login form
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    // create forgot form
    this.forgotForm = this.formBuilder.group({
      email: ['', Validators.required],
    });

    // create register form
    this.registerForm = this.formBuilder.group({
      company: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      position: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],
      role: ['exhibitor', Validators.required],
    });

    ////// -------------------------- firststart
    this.activities_en[0] = 'Accomodation';
    this.activities_en[1] = 'Barging';
    this.activities_en[2] = 'Carriers';
    this.activities_en[3] = 'Cultural Sites';
    this.activities_en[4] = 'Excursions / Entertainment';
    this.activities_en[5] = 'Incoming services';
    this.activities_en[6] = 'Leisure or entertainment park';
    this.activities_en[7] = 'Restaurant';
    this.activities_en[8] = 'Ski';
    this.activities_en[9] = 'Tourist office';
    this.activities_en[10] = 'Other';
    this.activities_en[11] = 'Shopping';
    this.activities_en[12] = 'Luxury offers';
    this.activities_en[13] = 'MICE Services';
    this.activities_fr[0] = 'Hébergement';
    this.activities_fr[1] = 'Location fluviale';
    this.activities_fr[2] = 'Transporteur';
    this.activities_fr[3] = 'Sites culturels';
    this.activities_fr[4] = 'Excursion, guide';
    this.activities_fr[5] = 'Agence réceptive';
    this.activities_fr[6] = "Parc d'attraction ou de loisirs";
    this.activities_fr[7] = 'Restaurant ';
    this.activities_fr[8] = 'Ski';
    this.activities_fr[9] = 'Office du Tourisme';
    this.activities_fr[10] = 'Autre';
    this.activities_fr[11] = 'Shopping';
    this.activities_fr[12] = 'Luxury offers';
    this.activities_fr[13] = 'MICE Services';
    // dies sind jetzt dynamische felder --> nicht mehr ergänzen

    // load and init the form
    this.firstExhibitorForm = this.formBuilder.group({
      uid: this.authQuery.userid,
      fid: this.authQuery.fid,
      role: this.authQuery.role,
      firststart_done: this.authQuery.firststart_done,

      // Required only when their checkbox is actually shown (matches the
      // *ngIf="showStorno"/"showDSGVO" in the template), so the control always
      // exists for the binding and never becomes an invisible required field.
      storno_accepted: [false, this.showStorno ? Validators.requiredTrue : []],
      dsgvo_accepted: [false, this.showDSGVO ? Validators.requiredTrue : []],
      agb_accepted: [false, this._terms_check ? Validators.requiredTrue : []],
      media_accepted: [false, this.showMedia ? Validators.requiredTrue : []],

      taxid_uid: ['', this._taxid_required ? Validators.required : []],
      special_wishes: [''],

      //profile_image: [''], // via filepond solved

      //organisation: ['', Validators.required],
      //name: ['', Validators.required],
      //vorname: ['', Validators.required],
      //funktion: ['', Validators.required],
      adresse: [this.fsData?.adresse, Validators.required],
      plz: [this.fsData?.plz, Validators.required],
      stadt: [this.fsData?.stadt, Validators.required],
      telefon: [this.fsData?.telefon, Validators.required],
      //fax: [this.fsData?.fax, Validators.required],
      email: [this.fsData?.email, [Validators.required, Validators.email]],
      web: [this.fsData?.web, Validators.required],

      category: ['', Validators.required],

      beschreibung: ['', Validators.required],
      info1: ['', Validators.required], // neuigkeiten

      // region
      regionsGroup: new FormGroup(
        {
          auvergne: new FormControl(false),
          bourgogne: new FormControl(false),
          bretagne: new FormControl(false),
          centreloire: new FormControl(false),
          corse: new FormControl(false),
          champagne: new FormControl(false),
          nordcalais: new FormControl(false),
          normandie: new FormControl(false),
          aquitaine: new FormControl(false),
          languedoc: new FormControl(false),
          outremer: new FormControl(false),
          paris: new FormControl(false),
          paysloire: new FormControl(false),
          picardie: new FormControl(false),
          paca: new FormControl(false),
          multiregions: new FormControl(false),
        },
        requireAtLeastOneCheckboxValidator(1)
      ),

      // ---- all these are now used for the dyn fields
      //alsace: new FormControl(false),
      //limousin: new FormControl(false),
      //lorraine: new FormControl(false),
      //midipyrenes: new FormControl(false),
      //poitoucharentes: new FormControl(false),
      //rhonealpes: new FormControl(false),
      //riveria: new FormControl(false),
      //monaco: new FormControl(false),
      //thaiti: new FormControl(false),
      //luxury: new FormControl(false),

      // ---------------------------------
      // this one is still not used !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      //mice: new FormControl(false),

      // activite
      activitiesGroup: new FormGroup(
        {
          agencereceptive: new FormControl(false),
          centralereservation: new FormControl(false),
          destination: new FormControl(false),
          excursion: new FormControl(false),
          groupement: new FormControl(false),
          locationfluviale: new FormControl(false),
          musee: new FormControl(false),
          transporteur: new FormControl(false),
          autre: new FormControl(false),
          offreski: new FormControl(false),
          ski_station: new FormControl(false),
          ski_rental: new FormControl(false),
          residencetourisme: new FormControl(false),
          restaurant: new FormControl(false),
        },
        requireAtLeastOneCheckboxValidator(1)
      ),

      // bilder
      //bild1: ['', Validators.required],
      //bild2: ['', Validators.required],
      //bild3: ['', Validators.required],
      //logo: ['', Validators.required],

      // tage teilnahme
      chkcity1: ['true'],
      chkcity2: ['true'],
      //chkcity3: ['', Validators.required],
      //chkcity4: ['', Validators.required],
      //chkcity5: ['', Validators.required],

      //room: ['', Validators.required],

      // logistic data form
      passport: [environment.add_exhibitor_bewegungsdaten.passport],
      linkedin: [environment.add_exhibitor_bewegungsdaten.linkedin],
      birthdate: [environment.add_exhibitor_bewegungsdaten.birthdate],
      hashtag: [environment.add_exhibitor_bewegungsdaten.hashtag],
      allergies: [environment.add_exhibitor_bewegungsdaten.allergies],
      nahrungsmittelunvertraglichkeit: [environment.add_exhibitor_bewegungsdaten.nahrungsmittelunvertraglichkeit],

      langulage_guide: [environment.add_exhibitor_bewegungsdaten.langulage_guide],
      image_videos: [environment.add_exhibitor_bewegungsdaten.image_videos],
      zielgruppe_angebote: [environment.add_exhibitor_bewegungsdaten.zielgruppe_angebote],

      type_anreise: [environment.add_exhibitor_bewegungsdaten.arrival.type_anreise],
      departure_location: [environment.add_exhibitor_bewegungsdaten.arrival.departure_location],
      arrival_departure_time: [environment.add_exhibitor_bewegungsdaten.arrival.arrival_departure_time],
      arrival_time: [environment.add_exhibitor_bewegungsdaten.arrival.arrival_time],
      arrival_plane_selber: [environment.add_exhibitor_bewegungsdaten.arrival.arrival_plane_selber],
      arrival_plane_atout: [environment.add_exhibitor_bewegungsdaten.arrival.arrival_plane_atout],
      parking_space: [environment.add_exhibitor_bewegungsdaten.arrival.parking_space],
      arrival_day_before: [environment.add_exhibitor_bewegungsdaten.arrival.arrival_day_before],

      departure_type_departure: [environment.add_exhibitor_bewegungsdaten.departure.departure_type_departure],
      departure_time: [environment.add_exhibitor_bewegungsdaten.departure.departure_time],
      departure_plane_selber: [environment.add_exhibitor_bewegungsdaten.departure.departure_plane_selber],

      participate: [environment.add_exhibitor_bewegungsdaten.post_event.participate],
      haftungsfreistellung: [environment.add_exhibitor_bewegungsdaten.post_event.haftungsfreistellung],

      lunch1: [environment.add_exhibitor_bewegungsdaten.event.lunch1],
      lunch2: [environment.add_exhibitor_bewegungsdaten.event.lunch2],
      lunch3: [environment.add_exhibitor_bewegungsdaten.event.lunch3],
      nimes_visit: [environment.add_exhibitor_bewegungsdaten.event.nimes_visit],
    });

    // add the dyn fields
    const regionsKeys = this.getKeysRegions();
    const activitiesKeys = this.getKeysActivities();

    regionsKeys.forEach((key, index) => {
      if (this.show_dyn_regions_ex[index]) {
        (this.firstExhibitorForm.get('regionsGroup') as FormGroup).addControl(key, new FormControl(false));
      }
    });

    activitiesKeys.forEach((key, index) => {
      if (this.show_dyn_activities_ex[index]) {
        (this.firstExhibitorForm.get('activitiesGroup') as FormGroup).addControl(key, new FormControl(false));
      }
    });
  }

  ngOnInit(): void {
    //console.log('init');

    // check if mobile device --> then show login form
    if (this.isMobile) {
      if (!this.dialogIsShown) {
        //this.toggleBackdrop('overlay');
        this.toggleShowForm('myForm');
        this.dialogIsShown = true;
      }
    }

    // --------------------------------------------
    // does the exhibitor
    // load the dyn fields
    // --- > this is done way down in the firststart !

    // if the user is the admin -> terms do not need to be checked
    // as the user himself needs to set that
    const role = this.authQuery.role;

    if (role == 1) {
      this.firstExhibitorForm.get('storno_accepted')?.clearValidators();
      this.firstExhibitorForm.get('dsgvo_accepted')?.clearValidators();
      this.firstExhibitorForm.get('agb_accepted')?.clearValidators();
      this.firstExhibitorForm.get('media_accepted')?.clearValidators();
    }
  }

  ngOnChanges() {}

  /** Brand logo above the welcome heading (Media tab → brand_logo, else static asset). */
  get welcomeLogoUrl(): string {
    const rel = (environment as any).brand_logo;
    if (rel) {
      return `${environment.eplusSystem}/_fileDB/${rel}`;
    }
    return './assets/logo-france.jpg';
  }

  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  animationState = 'out';
  backdropState = 'out';

  toggleBackdrop(divName: string) {
    this.backdropState = this.backdropState === 'out' ? 'in' : 'out';
  }
  toggleShowForm(divName: string) {
    this.animationState = this.animationState === 'out' ? 'in' : 'out';
  }

  onMouseEnter() {
    //console.log('mouse enter');

    if (!this.dialogIsShown) {
      this.toggleBackdrop('overlay');
      this.toggleShowForm('myForm');
      this.dialogIsShown = true;
    }
  }

  /**
   * Fired when the slideInOut animation on .myForm finishes. Once the dialog is
   * opaque, force one layout/change-detection pass so the (Material) content is
   * measured against a visible container - guarantees the box is never shown
   * blank waiting for a later mouse-move to trigger re-measurement.
   */
  onDialogShown() {
    if (this.dialogIsShown) {
      this.cdr.detectChanges();
      window.dispatchEvent(new Event('resize'));
    }
  }

  @HostListener('mousleave', ['$event'])
  onMouseLeave(event: any) {
    //console.log('mouse leave');

    // window height and width
    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;

    let posX = event.pageX;
    let posY = event.pageY;

    let outOfWindow = false;

    // console.log('coords x: ' + event.pageX + ' y: ' + event.pageY);

    if (posX < 0 || posX > screenWidth) {
      //console.log('out');
      outOfWindow = true;
    }

    if (posY < 0 || posY > screenHeight) {
      //console.log('out');
      outOfWindow = true;
    }

    if (this.dialogIsShown && outOfWindow && !this.fsShowFiles) {
      this.toggleBackdrop('overlay');
      this.toggleShowForm('myForm');
      this.dialogIsShown = false;
    }
  }

  @HostListener('window:focus', ['$event'])
  onFocused() {
    //this.toggleBackdrop('overlay');
    //this.toggleShowForm('myForm');
  }
  @HostListener('window:blur', ['$event'])
  onBlur() {
    //this.toggleShowForm('myForm');
    //this.toggleBackdrop('overlay');
    //this.dialogIsShown = false;
  }

  /*
  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    console.log('visibility change');
    this.toggleShowForm('myForm');
    this.toggleBackdrop('overlay');
  }
*/

  fullScreen() {
    this.myVideo = document.getElementById('video');
    this.videoContainer = document.getElementById('video-container-id');

    if (document.fullscreenElement) {
      document.exitFullscreen();
      this.myVideo.style.height = '250px';
      this.myVideo.style.width = '100%';
    } else {
      this.videoContainer.requestFullscreen();
      this.videoTag.nativeElement.style.height = '100%';
      this.videoTag.nativeElement.style.width = '100%';
    }
  }

  /* video controls */
  togglePlay() {
    this.playing = !this.playing;
    this.playingIcon = this.playing ? 'play_arrow' : 'pause';

    this.myVideo = document.getElementById('video');
    if (this.myVideo.paused) this.myVideo.play();
    else this.myVideo.pause();
  }

  toggleMute() {
    this.mute = !this.mute;
    this.muteIcon = this.mute ? 'volume_mute' : 'volume_up';
  }

  toggleEye() {
    this.eye = !this.eye;
    this.eyeIcon = this.eye ? 'visibility' : 'visibility_off';
  }

  /*
  forgot - signup - login */

  goLogin() {
    this.activeTab = myTabs.tabLogin;
  }

  goForgot() {
    this.activeTab = myTabs.tabForgotPawd;
  }

  goSignup() {
    this.activeTab = myTabs.tabRegisterNew;
  }

  goRegisterSuccess() {
    this.activeTab = myTabs.tabRegisterSuccess;
  }

  /**
   *
   *
   */
  login() {
    this.isLoading = true;
    this.submitted = true;

    // only click once
    if (this.isLoginClicked) {
      return;
    }
    this.isLoginClicked = true;

    const login$ = this.authService.login(this.loginForm.value);
    login$
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = true;
          this.isLoginClicked = false;
        })
      )
      .subscribe(
        (data) => {
          //
          // check for error
          //
          if (data.status === 401) {
            console.log('login error');

            // show error message
            if (data.error == 'PENDING_APPROVAL') {
              // pending approval (not yet approved)
              this._snackBar.open('Your registration is still looked at.', 'Close', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                duration: 3000,
                // panelClass: ['mat-toolbar', 'mat-primary'],
              });
            } else {
              // username or password wrong
              this._snackBar.open('Error: Username or password were wrong.', 'Close', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                duration: 3000,
                // panelClass: ['mat-toolbar', 'mat-primary'],
              });
            }
            return;
          } else {
            //
            // everything went OK
            //
            log.debug(`${data.name} successfully logged in`);

            const access_token = this.authQuery.access_token;
            const userid = this.authQuery.userid;
            const fid = this.authQuery.fid;
            const role = this.authQuery.role;

            this.journalService.log('Anmeldung erfolgreich.   --------------------------------------');
            this.cookieService.set('logged-on-today', '1', new Date()); // remember me funktion

            // create a cookie
            // not implemented yet
            // check if firststart is done
            if (data.firststart_done == 1 && data.isactivated == 1) {
              // if the user is an admin
              // go to the new dashboard

              // else goto the old system -belogin

              if (data.role == 1) {
                // admin
                this.router.navigate(['/home']);
              } else {
                // visitor or exhibitor
                // goto eventplus system
                const myform = document.createElement('form');
                myform.method = 'POST';
                myform.action = environment.eplusSystem + '/belogin.php';
                myform.style.display = 'none';
                myform.append('Content-Type', 'application/x-www-form-urlencoded');
                myform.append('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');

                const inputAuth = document.createElement('input');
                inputAuth.type = 'hidden';
                inputAuth.name = 'Authorization';
                inputAuth.value = access_token;
                myform.appendChild(inputAuth);

                const inputUid = document.createElement('input');
                inputUid.type = 'hidden';
                inputUid.name = 'uid';
                inputUid.value = '' + userid;
                myform.appendChild(inputUid);

                const inputFid = document.createElement('input');
                inputFid.type = 'hidden';
                inputFid.name = 'fid';
                inputFid.value = '' + fid;
                myform.appendChild(inputFid);

                const inputRole = document.createElement('input');
                inputRole.type = 'hidden';
                inputRole.name = 'role';
                inputRole.value = '' + role;
                myform.appendChild(inputRole);

                document.body.appendChild(myform);
                myform.submit();
              }
            } else {
              // if (data.firststart_done == 0)
              //
              // weiche ---> je nachem
              // ob visitor | exhibitor
              //

              // goto firststart
              if (data.role == 2) {
                // exhibitor == 2
                this.activeTab = myTabs.tabFirststart;
                this.colLarge = 8;
                this.colXLarge = 8;

                // and now get the existing exhibitor data
                // so the exhibitor can change the already existing data

                // get the visitor with the given ID
                this.exhibitorService.getExhibitorById(fid).subscribe((exhibitor: ExhibitorSingle) => {
                  console.log('exhibitor from DB');
                  console.log(exhibitor);

                  // set the profile image
                  this._profile_image = exhibitor.data.profile_image;
                  this._logo = exhibitor.data.logo;
                  this._bild1 = exhibitor.data.bild1;
                  this._bild2 = exhibitor.data.bild2;
                  this._bild3 = exhibitor.data.bild3;
                  this._imagevideo = exhibitor.data.data3;
                  this._presentationvideo = exhibitor.data.evening_video;

                  // const access_token = this.authQuery.access_token;

                  this.firstExhibitorForm.patchValue({
                    uid: userid,
                    fid: fid,
                    role: role,
                    //firststart_done: this.authQuery.firststart_done,

                    // judical things
                    //storno_accepted: exhibitor.data.storno_accepted == -1 ? true : false,
                    //dsgvo_accepted: exhibitor.data.dsgvo_accepted == -1 ? true : false,
                    agb_accepted: exhibitor.data.agb_accepted == -1 ? true : false,

                    // special wishes
                    special_wishes: exhibitor.data.special_wishes,
                    taxid_uid: exhibitor.data.uid,

                    // admin register new fields
                    company: exhibitor.data.organisation,
                    firstname: exhibitor.data.vorname,
                    lastname: exhibitor.data.name,
                    position: exhibitor.data.funktion,
                    //country: exhibitor.data.country,

                    //
                    adresse: exhibitor.data.adresse,
                    plz: exhibitor.data.plz,
                    stadt: exhibitor.data.stadt,
                    telefon: exhibitor.data.telefon,
                    email: exhibitor.data.email,
                    web: exhibitor.data.web,

                    category: exhibitor.data.category,
                    beschreibung: exhibitor.data.beschreibung,
                    info1: exhibitor.data.info1,

                    //Days
                    chkcity1: exhibitor.data.chkcity1 == 1 ? true : false,
                    chkcity2: exhibitor.data.chkcity2 == 1 ? true : false,

                    // logistic data form
                    passport: exhibitor.data.json.passport,
                    linkedin: exhibitor.data.json.linkedin,
                    birthdate: exhibitor.data.json.birthdate,
                    hashtag: exhibitor.data.json.hashtag,
                    allergies: exhibitor.data.json.allergies,
                    nahrungsmittelunvertraglichkeit: exhibitor.data.json.nahrungsmittelunvertraglichkeit,

                    langulage_guide: exhibitor.data.json.langulage_guide,
                    image_videos: exhibitor.data.json.image_videos,
                    zielgruppe_angebote: exhibitor.data.json.zielgruppe_angebote,

                    // arrival
                    type_anreise: exhibitor.data.json.arrival.type_anreise,
                    departure_location: exhibitor.data.json.arrival.departure_location,
                    arrival_departure_time: exhibitor.data.json.arrival.arrival_departure_time,
                    arrival_time: exhibitor.data.json.arrival.arrival_time,
                    arrival_plane_selber: exhibitor.data.json.arrival.arrival_plane_selber,
                    arrival_plane_atout: exhibitor.data.json.arrival.arrival_plane_atout,
                    parking_space: exhibitor.data.json.arrival.parking_space,
                    arrival_day_before: exhibitor.data.json.arrival.arrival_day_before,

                    // departure
                    departure_type_departure: exhibitor.data.json.departure.departure_type_departure,
                    departure_time: exhibitor.data.json.departure.departure_time,
                    departure_plane_selber: exhibitor.data.json.departure.departure_plane_selber,

                    // post-event
                    participate: exhibitor.data.json.post_event.participate,
                    haftungsfreistellung: exhibitor.data.json.post_event.haftungsfreistellung,

                    // event
                    lunch1: exhibitor.data.json.event.lunch1,
                    lunch2: exhibitor.data.json.event.lunch2,
                    lunch3: exhibitor.data.json.event.lunch3,
                    nimes_visit: exhibitor.data.json.event.nimes_visit,
                  });

                  this.firstExhibitorForm.controls['regionsGroup'].patchValue({
                    auvergne: exhibitor.data.auvergne == -1 ? true : false,
                    bourgogne: exhibitor.data.bourgogne == -1 ? true : false,
                    bretagne: exhibitor.data.bretagne == -1 ? true : false,
                    centreloire: exhibitor.data.centreloire == -1 ? true : false,
                    corse: exhibitor.data.corse == -1 ? true : false,
                    champagne: exhibitor.data.champagne == -1 ? true : false,
                    nordcalais: exhibitor.data.nordcalais == -1 ? true : false,
                    normandie: exhibitor.data.normandie == -1 ? true : false,
                    aquitaine: exhibitor.data.aquitaine == -1 ? true : false,
                    languedoc: exhibitor.data.languedoc == -1 ? true : false,
                    outremer: exhibitor.data.outremer == -1 ? true : false,
                    paris: exhibitor.data.paris == -1 ? true : false,
                    paysloire: exhibitor.data.paysloire == -1 ? true : false,
                    picardie: exhibitor.data.picardie == -1 ? true : false,
                    paca: exhibitor.data.paca == -1 ? true : false,
                    multiregions: exhibitor.data.multiregions == -1 ? true : false,
                  });

                  this.firstExhibitorForm.controls['activitiesGroup'].patchValue({
                    agencereceptive: exhibitor.data.agencereceptive == -1 ? true : false,
                    centralereservation: exhibitor.data.centralereservation == -1 ? true : false,
                    destination: exhibitor.data.destination == -1 ? true : false,
                    excursion: exhibitor.data.excursion == -1 ? true : false,
                    groupement: exhibitor.data.groupement == -1 ? true : false,
                    locationfluviale: exhibitor.data.locationfluviale == -1 ? true : false,
                    musee: exhibitor.data.musee == -1 ? true : false,
                    transporteur: exhibitor.data.transporteur == -1 ? true : false,
                    autre: exhibitor.data.autre == -1 ? true : false,
                    offreski: exhibitor.data.offreski == -1 ? true : false,
                    ski_station: exhibitor.data.ski_station == -1 ? true : false,
                    ski_rental: exhibitor.data.ski_rental == -1 ? true : false,
                    residencetourisme: exhibitor.data.residencetourisme == -1 ? true : false,
                    restaurant: exhibitor.data.restaurant == -1 ? true : false,
                  });

                  //
                  // ------------------ load the dyn fields
                  //
                  const regionsKeys = this.getKeysRegions();
                  const activitiesKeys = this.getKeysActivities();

                  /*
                  regionsKeys.forEach((key, index) => {
                    if (this.show_dyn_regions_ex[index]) {
                      (this.firstExhibitorForm.get('regionsGroup') as FormGroup).addControl(key, new FormControl(false));
                    }
                  });

                  activitiesKeys.forEach((key, index) => {
                    if (this.show_dyn_activities_ex[index]) {
                      (this.firstExhibitorForm.get('activitiesGroup') as FormGroup).addControl(key, new FormControl(false));
                    }
                  });
                  */

                  // and now we aldo have to patch the values of the dynamic form fields
                  // Patch regions group values
                  const regionsGroupValues = {};
                  regionsKeys.forEach((key) => {
                    regionsGroupValues[key] = exhibitor.data[key] == '-1' ? true : false;
                  });
                  (this.firstExhibitorForm.get('regionsGroup') as FormGroup).patchValue(regionsGroupValues);

                  // Patch activities group values
                  const activitiesGroupValues = {};
                  activitiesKeys.forEach((key) => {
                    activitiesGroupValues[key] = exhibitor.data[key] == '-1' ? true : false;
                  });
                  (this.firstExhibitorForm.get('activitiesGroup') as FormGroup).patchValue(activitiesGroupValues);
                });

                //
                // -------------
              } else {
                // we assume visitor (this is also if it is admin)

                let uid = this.authQuery.userid;
                let fid = this.authQuery.fid;
                let role = this.authQuery.role;
                let country = this.authQuery.country;
                let firststart_done = this.authQuery.firststart_done;

                this.router.navigate(['/firststart', { id: fid, _uid: uid, _fid: fid, _role: 3, _country: country, ia: 0 }]);
              }
            }

            /*
          this.router.navigate(
            [this.route.snapshot.queryParams['redirect'] || '/'],
            { replaceUrl: true }
          );
          */
          }
        },
        (error) => {
          log.debug(`Login error: ${error}`);
          this.error = error;
        }
      );
  }

  /**
   *
   *
   * @memberof PhutureLoginComponent
   */
  forgot() {
    /*
    var email = this.forgotForm.controls['email'].value;

    let data = {
      email: email
    };
    */
    this.submitted = true;
    this.isLoading = true;

    // only click once
    if (this.isForgetClicked) {
      return;
    }
    this.isForgetClicked = true;

    const changePwd$ = this.authService.forgotpwd(this.forgotForm.value);
    changePwd$
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
          this.isForgetClicked = false;
        })
      )
      .subscribe(
        (data: any) => {
          console.log(data);

          // show done notification alert
          if (data.code == 200) {
            this._snackBar.open('Kennwortanfrage erfolgreich geschickt', 'Schließen', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 3000,
            });
          } else {
            this._snackBar.open('Fehler aufgetreten.', 'Schließen', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 3000,
            });
          }
        },
        (error: any) => {
          // show error notification alert
          this._snackBar.open('Fehler aufgetreten', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
      );
  }

  /**
   *
   *
   * @memberof PhutureLoginComponent
   */
  register() {
    console.log('check server > register new');
    this.submitted = true;
    this.isLoading = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // only click once
    if (this.isRegisterNewClicked) {
      return;
    }
    this.isRegisterNewClicked = true;

    const register$ = this.authService.register(this.registerForm.value);
    register$
      .pipe(
        finalize(() => {
          this.registerForm.markAsPristine();
          this.isLoading = false;
          this.isRegisterNewClicked = false;
        })
      )
      .subscribe(
        (data) => {
          log.debug(`${data.name} successfully registered`);
          //this.router.navigate([this.route.snapshot.queryParams['redirect'] || '/'], { replaceUrl: true });
          this.goRegisterSuccess();
        },
        (error) => {
          log.debug(`Login error: ${error}`);
          this.error = error;

          this._snackBar.open('Error: E-Mail exists already', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
      );
  }

  //
  //
  // -------------------------------------- firststart
  //

  selectedIndex: number = 0;

  setIndex(event) {
    this.selectedIndex = event.selectedIndex;
  }
  triggerClick() {
    //console.log(`Selected tab index: ${this.selectedIndex}`);
    if (this.selectedIndex == 4) {
      // wenn es sich um das file-drag-and-drop handelt
      // dann soll beim mouse-move der dialog stehen bleiben
      this.fsShowFiles = true;
    } else {
      this.fsShowFiles = false;
    }
  }

  showFirststart(event) {
    console.log('hidden click');
    if (event.ctrlKey) {
      //this.router.navigate(['/firststart']);
    }
  }

  /**
   *  --------------- dynamic field keys
   *
   */
  getKeysRegions() {
    return Object.keys(this.caption_dyn_regions_ex);
  }

  getKeysActivities() {
    return Object.keys(this.caption_dyn_activities_ex);
  }

  /**
   *
   *
   */
  submitFirststart() {
    console.log('submit');
    this.submitted = true;

    // stop here if form is invalid
    if (this.firstExhibitorForm.invalid) {
      const invalidFields = Object.keys(this.firstExhibitorForm.controls).filter((key) => this.firstExhibitorForm.get(key)?.invalid);

      console.warn('Invalid fields:', invalidFields); // Dev debugging
      //this.invalidFieldLabels = invalidFields; // Optional: for UI display
      return;
      // we do not care if it is invalid
      // because we do a cache save
      //
    } else {
      // first-start can set to 1
      // and then save it agin
      //  (click)="submitFirststart()"
      this.firstExhibitorForm.controls['firststart_done'].setValue(1);
    }

    // display form values on success
    this.submitted = true;
    if (this.firstExhibitorForm.valid) {
      //console.table(this.firstExhibitorForm.value);
    }

    // set the form params
    const access_token = this.authQuery.access_token;
    const userid = this.authQuery.userid;
    const fid = this.authQuery.fid;
    const role = this.authQuery.role;

    //this.firstExhibitorForm.controls['access_token'].setValue(access_token);
    this.firstExhibitorForm.controls['uid'].setValue(userid);
    this.firstExhibitorForm.controls['fid'].setValue(fid);
    this.firstExhibitorForm.controls['role'].setValue(role);

    //
    // additional data ?
    // lcmario
    //
    //
    // additional data ?
    //
    const form = this.firstExhibitorForm.value;
    const bewegungsdaten = {
      passport: form.passport,
      linkedin: form.linkedin,
      birthdate: form.birthdate,
      hashtag: form.hashtag,
      allergies: form.allergies,
      nahrungsmittelunvertraglichkeit: form.nahrungsmittelunvertraglichkeit,
      membership_level: form.membership_level,
      comm_log: form.comm_log,
      langulage_guide: form.langulage_guide,
      image_videos: form.image_videos,
      zielgruppe_angebote: form.zielgruppe_angebote,
      arrival: {
        type_anreise: form.type_anreise, // zug, auto, flugzeug
        departure_location: form.departure_location,
        arrival_departure_time: form.arrival_departure_time,
        arrival_time: form.arrival_time,
        arrival_plane_selber: form.arrival_plane_selber,
        arrival_plane_atout: form.arrival_plane_atout,
        parking_space: form.parking_space,
        arrival_day_before: form.arrival_day_before,
      },
      departure: {
        departure_type_departure: form.departure_type_departure, // zug, auto, flugzeug
        departure_time: form.departure_time,
        departure_plane_selber: form.departure_plane_selber,
      },
      post_event: {
        participate: form.participate, // radio: 0, 1, 2, 3
        haftungsfreistellung: form.haftungsfreistellung,
        link_form: 'https://www.workshop-france.de/eplus/_fileDB/terms.pdf',
      },
      event: {
        lunch1: form.lunch1,
        lunch2: form.lunch2,
        lunch3: form.lunch3,
        nimes_visit: form.nimes_visit,
      },
    };
    const stammdaten = environment.add_visitor_stammdaten;

    const payload = { ...this.firstExhibitorForm.value, data4: stammdaten, json: bewegungsdaten };

    const firststart$ = this.authService.firststart(payload);
    firststart$
      .pipe(
        finalize(() => {
          this.firstExhibitorForm.markAsPristine();
          this.isLoading = false;
        })
      )
      .subscribe(
        (data) => {
          if (data.status === 401) {
            console.log('login error');
            this._snackBar.open('Error: Something went wrong.', 'Close', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              duration: 3000,
              // panelClass: ['mat-toolbar', 'mat-primary'],
            });
          } else {
            log.debug(`${data.name} successfully firststart done`);

            this.journalService.log('FirstStart erfolgreich abgeschlossen.   --------------------------------------');

            // we got the data back -> zwischenspeicher
            // load based on role

            // exhibitor == 2
            if (data.role == 2) {
              // exhibitor
              console.table(data.exhibitor);

              this.fsData = data.exhibitor;
            }

            // visitor == 3
            if (data.role == 3) {
              // visitor
              console.table(data.visitor);

              this.fsData = data.visitor;
            }

            // get firststart done
            let firststart_done = +data.firststart_done;

            // now route the user into the eplus system (sso )
            if (firststart_done == 1) {
              console.log('route to backend ---- sso');

              const myform = document.createElement('form');
              myform.method = 'POST';
              myform.action = environment.eplusSystem + '/belogin.php';
              myform.style.display = 'none';
              myform.append('Content-Type', 'application/x-www-form-urlencoded');
              myform.append('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8');

              const inputAuth = document.createElement('input');
              inputAuth.type = 'hidden';
              inputAuth.name = 'Authorization';
              inputAuth.value = access_token;
              myform.appendChild(inputAuth);

              const inputUid = document.createElement('input');
              inputUid.type = 'hidden';
              inputUid.name = 'uid';
              inputUid.value = '' + userid;
              myform.appendChild(inputUid);

              const inputFid = document.createElement('input');
              inputFid.type = 'hidden';
              inputFid.name = 'fid';
              inputFid.value = '' + fid;
              myform.appendChild(inputFid);

              const inputRole = document.createElement('input');
              inputRole.type = 'hidden';
              inputRole.name = 'role';
              inputRole.value = '' + role;
              myform.appendChild(inputRole);

              document.body.appendChild(myform);
              myform.submit();
            } else {
              console.log('do nothing');
            }
          }
        },
        (error) => {
          log.debug(`Login error: ${error}`);
          this.error = error;
        }
      );
  }

  //
  // -----------------------------------------------------
  //

  selectedVisitor = false;
  onSelectVisitor() {
    this.selectedVisitor = !this.selectedVisitor;
  }
  selectedExhibitor = false;
  onSelectExhibitor() {
    this.selectedExhibitor = !this.selectedExhibitor;
  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    console.log('A file was added', event);
  }

  pondHandleActivateFile(event: any) {
    console.log('A file was activated', event);
  }

  getCountryName(country: string) {
    switch (country) {
      case 'at':
        return 'Austria';
      case 'ba':
        return 'Bosnia-Herzegovina';
      case 'bg':
        return 'Bulgaria';
      case 'hr':
        return 'Croatia';
      case 'cz':
        return 'Czech Republic';
      case 'fr':
        return 'France';
      case 'de':
        return 'Germany';
      case 'hu':
        return 'Hungary';
      case 'xk':
        return 'Kosovo';
      case 'mk':
        return 'Macedonia';
      case 'mne':
        return 'Montenegro';
      case 'pl':
        return 'Poland';
      case 'ro':
        return 'Romania';
      case 'xs':
        return 'Serbia';
      case 'sk':
        return 'Slovakia';
      case 'si':
        return 'Slovenia';
      case 'ch':
        return 'Switzerland';
      default:
        return '';
    }
  }

  getMimeType(filename: string): string {
    if (!filename) return '';
    const ext = filename.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'mp4':
        return 'video/mp4';
      case 'webm':
        return 'video/webm';
      default:
        return 'video/mp4'; // fallback
    }
  }
}
